// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1wgX2","expandIcon":"AccordionButton_expandIcon__2OmvG","expanded":"AccordionButton_expanded__2H1n0"};